import config from "../../config"
import RequestService from "../RequestService"

const deleteTicketImage = (ticketImageId, successCallback, failureCallback) => {
  RequestService.delete(`${config.backendUrl}/ticket_images/${ticketImageId}`, successCallback, failureCallback)
}

export default deleteTicketImage;